import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Chips } from 'components/atoms/Chips';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { batchStatusVariant, licencePrintStatusVariant } from 'pages/LicencesPage/helpers';

interface IPrintoutsHistoryTableCard {
  data: ITableDataSource;
}

export const PrintoutsHistoryTableCard = ({ data }: IPrintoutsHistoryTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        p: 2,
        rowGap: 2,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licence.applicationProcess.dateTime.label')}
        </Typography>
        <Typography variant="body2">{data.createdDate}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licence.applicationProcess.status.label')}
        </Typography>
        <Chips
          text={data.status}
          variant={licencePrintStatusVariant(data.statusUniqueId)}
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licence.applicationProcess.priceDescription.label')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(t(data.description))}</Typography>
      </Grid>
    </Grid>
  );
};
